import React, {memo} from "react";

export const IconPapers = memo(({color, addClass}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={addClass}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5 8.5H8.5C8.224 8.5 8 8.276 8 8V4C8 3.724 8.224 3.5 8.5 3.5H11.5C11.776 3.5 12 3.724 12 4V8C12 8.276 11.776 8.5 11.5 8.5ZM9 7.5H11V4.5H9V7.5Z"
        fill={color || "#000"}
      />
      <path
        d="M6.5 4.5H4.5C4.224 4.5 4 4.276 4 4C4 3.724 4.224 3.5 4.5 3.5H6.5C6.776 3.5 7 3.724 7 4C7 4.276 6.776 4.5 6.5 4.5Z"
        fill={color || "#000"}
      />
      <path
        d="M6.5 6.5H4.5C4.224 6.5 4 6.276 4 6C4 5.724 4.224 5.5 4.5 5.5H6.5C6.776 5.5 7 5.724 7 6C7 6.276 6.776 6.5 6.5 6.5Z"
        fill={color || "#000"}
      />
      <path
        d="M6.5 8.5H4.5C4.224 8.5 4 8.276 4 8C4 7.724 4.224 7.5 4.5 7.5H6.5C6.776 7.5 7 7.724 7 8C7 8.276 6.776 8.5 6.5 8.5Z"
        fill={color || "#000"}
      />
      <path
        d="M11.5 10.5H4.5C4.224 10.5 4 10.276 4 10C4 9.724 4.224 9.5 4.5 9.5H11.5C11.776 9.5 12 9.724 12 10C12 10.276 11.776 10.5 11.5 10.5Z"
        fill={color || "#000"}
      />
      <path
        d="M11.5 12.5H4.5C4.224 12.5 4 12.276 4 12C4 11.724 4.224 11.5 4.5 11.5H11.5C11.776 11.5 12 11.724 12 12C12 12.276 11.776 12.5 11.5 12.5Z"
        fill={color || "#000"}
      />
      <path
        d="M17.5 4.5H17V4C17 3.173 16.327 2.5 15.5 2.5H15V2C15 1.173 14.327 0.5 13.5 0.5H2.5C1.673 0.5 1 1.173 1 2V14C1 14.827 1.673 15.5 2.5 15.5H3V16C3 16.827 3.673 17.5 4.5 17.5H5V18C5 18.827 5.673 19.5 6.5 19.5H17.5C18.327 19.5 19 18.827 19 18V6C19 5.173 18.327 4.5 17.5 4.5ZM2 14V2C2 1.724 2.224 1.5 2.5 1.5H13.5C13.776 1.5 14 1.724 14 2V14C14 14.276 13.776 14.5 13.5 14.5H2.5C2.224 14.5 2 14.276 2 14ZM4 16V15.5H13.5C14.327 15.5 15 14.827 15 14V3.5H15.5C15.776 3.5 16 3.724 16 4V16C16 16.276 15.776 16.5 15.5 16.5H4.5C4.224 16.5 4 16.276 4 16ZM18 18C18 18.276 17.776 18.5 17.5 18.5H6.5C6.224 18.5 6 18.276 6 18V17.5H15.5C16.327 17.5 17 16.827 17 16V5.5H17.5C17.776 5.5 18 5.724 18 6V18Z"
        fill={color || "#000"}
      />
    </svg>
  );
});
